import {
  Badge,
  BadgeSize,
  BadgeVariant,
  Checkbox,
  CheckboxSize
} from "shared/components";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { cx } from "shared/utils";
import { BrandingTarget } from "types/landlord/address";
import { getTargetName, isPmsSynced } from "./helpers";

type TargetStatus = "pms-synced" | "has-own-branding" | "none";

const getTargetStatus = (target: BrandingTarget): TargetStatus => {
  if (isPmsSynced(target)) return "pms-synced";
  if (target.has_existing_branding) return "has-own-branding";

  return "none";
};

const TargetBadge = ({ status }: { status: TargetStatus }) => {
  if (status === "pms-synced")
    return (
      <Badge
        className="shrink-0"
        size={BadgeSize.SM}
        variant={BadgeVariant.BASE}
      >
        Synced from PMS
      </Badge>
    );

  if (status === "has-own-branding")
    return (
      <Badge
        className="shrink-0"
        size={BadgeSize.SM}
        variant={BadgeVariant.WARNING}
      >
        Has its own branding
      </Badge>
    );

  return null;
};

export const PropertyChecklistRow = ({
  target,
  checked,
  onToggle
}: {
  target: BrandingTarget;
  checked: boolean;
  onToggle: () => void;
}) => {
  const dictionary = useUnitsPropertiesDictionary();
  const status = getTargetStatus(target);
  const pmsSynced = status === "pms-synced";

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="min-w-0">
        <Checkbox
          checked={checked}
          disabled={pmsSynced}
          id={`branding-target-${target.id}`}
          label={getTargetName(target, dictionary)}
          onChange={onToggle}
          size={CheckboxSize.SM}
        />
        <p
          className={cx(
            "truncate pl-6 text-sm",
            pmsSynced ? "text-content-100" : "text-content-400"
          )}
        >
          {target.address || "No address"}
        </p>
      </div>

      <TargetBadge status={status} />
    </div>
  );
};
